import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// AUTH
export const MediatorLoginPage = Loadable(lazy(() => import('../pages/auth/mediator/LoginPage')));

// DASHBOARD: MEDIATOR
export const MediatorDashboardPage = Loadable(
  lazy(() => import('../pages/mediator/DashboardPage'))
);
export const FatturazionePage = Loadable(lazy(() => import('../pages/mediator/FatturazionePage')));
export const BookingListPage = Loadable(lazy(() => import('../pages/mediator/BookingListPage')));
export const BookingViewPage = Loadable(lazy(() => import('../pages/mediator/BookingViewPage')));
export const MediatorPage = Loadable(lazy(() => import('../pages/mediator/MediatorAccountPage')));
export const InvoiceListPage = Loadable(lazy(() => import('../pages/mediator/InvoiceListPage')));
export const InvoiceCreate = Loadable(lazy(() => import('../pages/mediator/InvoiceCreatePage')));
export const InvoiceDetailPage = Loadable(
  lazy(() => import('../pages/mediator/InvoiceDetailPage'))
);
export const TranslationOrdersPage = Loadable(
  lazy(() => import('../pages/mediator/TranslationOrdersPage'))
);
// MAIN

export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const HomePage = Loadable(lazy(() => import('../pages/HomePage')));
export const ComingSoonPage = Loadable(lazy(() => import('../pages/ComingSoonPage')));
